
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";

export interface FilterValues {
  dateFrom: string;
  dateTo: string;
  accountName: string;
  platform: string;
  postType: string;
}

interface FilterBarProps {
  filters: FilterValues;
  onChange: (filters: FilterValues) => void;
  showPlatform?: boolean;
  showPostType?: boolean;
  accounts?: string[];
  postTypes?: string[];
}

const PLATFORM_LABELS: Record<string, string> = {
  all: "Všechny",
  facebook: "Facebook",
  instagram: "Instagram",
};

export function FilterBar({
  filters,
  onChange,
  showPlatform = false,
  showPostType = false,
  accounts = [],
  postTypes = [],
}: FilterBarProps) {
  const update = (partial: Partial<FilterValues>) => {
    onChange({ ...filters, ...partial });
  };

  return (
    <div className="flex flex-wrap items-center gap-3 p-4 bg-card border rounded-lg">
      <Input
        type="date"
        value={filters.dateFrom}
        onChange={(e) => update({ dateFrom: e.target.value })}
        className="w-[160px]"
      />
      <span className="text-muted-foreground text-sm">—</span>
      <Input
        type="date"
        value={filters.dateTo}
        onChange={(e) => update({ dateTo: e.target.value })}
        className="w-[160px]"
      />

      <Select
        value={filters.accountName}
        onValueChange={(v) => update({ accountName: v ?? "all" })}
      >
        <SelectTrigger className="w-[260px]">
          <SelectValue placeholder="Účet / Restaurace">
            {(v: string) => (v === "all" ? `Všechny účty (${accounts.length})` : v)}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Všechny účty ({accounts.length})</SelectItem>
          {accounts.map((name) => (
            <SelectItem key={name} value={name}>{name}</SelectItem>
          ))}
        </SelectContent>
      </Select>

      {showPlatform && (
        <Select
          value={filters.platform}
          onValueChange={(v) => update({ platform: v ?? "all" })}
        >
          <SelectTrigger className="w-[150px]">
            <SelectValue placeholder="Platforma">
              {(v: string) => PLATFORM_LABELS[v] ?? v}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Všechny</SelectItem>
            <SelectItem value="facebook">Facebook</SelectItem>
            <SelectItem value="instagram">Instagram</SelectItem>
          </SelectContent>
        </Select>
      )}

      {showPostType && (
        <Select
          value={filters.postType}
          onValueChange={(v) => update({ postType: v ?? "all" })}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Typ postu">
              {(v: string) => (v === "all" ? "Všechny typy" : v)}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Všechny typy</SelectItem>
            {postTypes.map((t) => (
              <SelectItem key={t} value={t}>{t}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
